module.exports = __webpack_public_path__ + "static/media/78.502ebf22.webp";